import * as React from 'react';
import ManutationPanel from '../manutationpanel';

export function MaxManutation() {
  return (<div style={{ textAlign: 'center' }}>
    <ManutationPanel
      endpointBase="/server/maxCommand/botManutation"
      systemLabel="Max"
    />
  </div>);
}
